var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-page',{attrs:{"no-padding":"","white":!_vm.isFeedThread}},[_c('div',{class:[
      {
        '--comments': _vm.isCommentThread,
        '--feed': _vm.isFeedThread,
        'bg-white': !_vm.isFeedThread,
        'h-full': !_vm.isCommentThread
      },
      'message-thread__page'
    ]},[(_vm.isLoading || !_vm.hasCheckedAuthentication)?[_c('div',{staticClass:"w-100 h-full d-flex align-items-center justify-content-center"},[_c('v-loader')],1)]:(_vm.messageThreadId)?[_c('thread-header',{attrs:{"message-thread":_vm.messageThread}}),_c('message-thread',{attrs:{"with-reactions":_vm.showReactions,"message-thread-id":_vm.messageThreadId,"is-comment-thread":_vm.isCommentThread,"placeholder":_vm.isCommentThread ? 'Write a reply...' : 'Write something...'}})]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }